// 新项目的域名
export const NIO_CONFIGURATOR_DOMAINS = [
  'https://config-front-test.nioint.com',
  'https://config-front-stg.nio.com',
  'https://config-front.nio.com',
  'https://order-front-h5-test.nioint.com',
  'https://order-front-h5-stg.nio.com',
  'https://order-front-h5.nio.com',
]
